import {getCompantPageByEs, findPublicCityTop} from "@/api/enterprise";

const state = {
    workplaceOption: [],    // 城市
    companyList: [],    // 企业
    searchParams: {
        pageSize: 16,   // 每页加载数据量
        pageNumber: 1,  // 页码
        willNature: '', // 工作性质（实习，兼职，全职）
        function: '',   // 职能
        wageList: [],   // 薪酬集合
        workplace: '',  // 工作地点
        keyword: '',    // 关键词
    },
    page: {
        totalElements: 0    // 分页总数据量
    }
};

// getters
const getters = {};

const actions = {
    /** 获取职位列表*/
    getCompanyList({state, commit}) {
        return new Promise((resolve, reject) => {
            let params = Object.assign({}, state.searchParams);
            getCompantPageByEs(params).then((res) => {
                commit("SET_COMPANY", res.data.content);
                commit("SET_COMPANY_ELEMENTS", parseInt(res.data.totalElements));
                resolve(res);
            });
        });
    },
    /** 获取简历城市列表*/
    getCompanyCityList({state, commit}) {
        return new Promise((resolve, reject) => {
            if (state.workplaceOption.length > 0) {
                return;
            }
            findPublicCityTop().then((res) => {
                commit("SET_SEARCH_CITY", res.data);
                resolve(res);
            });
        });
    },
};

// mutations
const mutations = {
    /** 设置职位列表*/
    SET_COMPANY(state, list) {
        state.companyList = list;
    },
    /** 设置分页总条数*/
    SET_COMPANY_ELEMENTS(state, size) {
        state.page.totalElements = size;
    },
    /** 设置查询条件中城市列表*/
    SET_SEARCH_CITY(state, list) {
        state.workplaceOption = list;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
